export const BNB = {
  name: 'BNB',
  symbol: 'BNB',
  address: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
  chainId: 56,
  decimals: 18,
  logoUrl: require('@/assets/img/bnb.png'),
};
export const ETH = {
  name: 'ETH',
  symbol: 'ETH',
  address: '0xc778417e063141139fce010982780140aa0cd5ab',
  chainId: 97,
  decimals: 18,
  logoUrl: 'https://res.cloudinary.com/sushi-cdn/image/fetch/w_128/https://raw.githubusercontent.com/sushiswap/icons/master/token/unknown.png',
};
